import './Navbar.css';
import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../../assets/images/amtex_logo.png';

function Navbar() {
  return (
    <header className="navbar-simple">
      <div className="navbar-left">
        <img src={logo} alt="Logo Amtex" className="navbar-logo" />
      </div>

      <nav className="navbar-right">
        <NavLink
          to="/news-stand"
          className={({ isActive }) =>
            isActive ? 'nav-link active' : 'nav-link'
          }
        >
          Banca
        </NavLink>
        <NavLink
          to="/news-listing"
          className={({ isActive }) =>
            isActive ? 'nav-link active' : 'nav-link'
          }
        >
          Notícias
        </NavLink>
      </nav>
    </header>
  );
}

export default Navbar;
